import React from "react";
import "./Footer.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faTicket } from "@fortawesome/free-solid-svg-icons";
import {
  faTwitter,
  faLinkedin,
  faInstagram,
  faInstagramSquare,
  faFacebook,
  faFacebookSquare,
  faYoutubeSquare,
} from "@fortawesome/free-brands-svg-icons";

import footerLogo from "../assets/images/footer-logo.svg";
import FooterSearchIcon from "../assets/images/footer-search-icon.png";
import InstagramIcon from "../assets/images/instagram-icon.png";
import LinkedinIcon from "../assets/images/linkedin-icon.png";
import FacebookIcon from "../assets/images/facebook-icon.png";
import YoutubeIcon from "../assets/images/youtube-icon.png";
import LinktreeIcon from "../assets/images/linktree.png";
import MediumLogo from "../assets/images/medium-logo.png";

const Footer = () => {
  return (
    <div className="footer__container" id="footerid">
      <div className="footer">
        <div className="footer--image-block">
          <a href="http://myequation.in/" target="_blank">
            <img src={footerLogo} className="footer__logo-image" />
          </a>
          <p className="foot--txt">
            India's only startup to provide an ecosystem for core engineers
          </p>
          <div></div>
        </div>
        <div className="footer--middle">
          <div className="footer__contact-container">
            <div className="footer-address-bar">
            <div className="footer-address-text">
             <div className="address-text01">
              <span>Ahmedabad Office</span> 
              <p>AIC GUSEC, Atal Kalam building, Gujarat University, Ahmedabad 380006</p>
             </div> 
            <div className="footeraddress">
            <div className="footer__contact-card">
              <p>Gunesh - 8806806479</p>
              <p>(SMO Head)</p>
            </div>
            <div className="footer__contact-card">
              <p>Nikhil - 8269497779</p>
              <p>(OutReach)</p>
            </div>            
            </div>
            </div> 
            {/* <div className="footer-address-text"> 
            <div className="address-text01">
              <span>Pune Office</span>
              <p>The Boardroom Co Working space, Pride Gateway, Baner, Pune</p>
            </div> 
            <div className="footer__contact-card">
              <p>Nikhil - 8269497779</p>
              <p>(OutReach)</p>
            </div>
            </div> */}
            </div>
            {/* <div className="footer-search">
              <input type="text" placeholder="FILL YOUR DETAILS" />
              <span className="footer-search-icon">
                <img src={FooterSearchIcon} className="search-icon" />
              </span>
            </div> */}
          </div>

          <div
            className="footer-Follow-us"
            style={{
              display: "flex",
              // flexDirection: "column",
              gap: "10px",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "40px",
            }}
          >
            <p
              className="footer-follow-text"
              style={{
                textAlign: "center",
              }}
            >
              Follow us on !
            </p>
            <div className="footer__brand--container">
              <a href="https://www.instagram.com/myequation.in/" target="_blank">
              <FontAwesomeIcon
                icon={faInstagramSquare}
                color="#fff"
                className="footer__brand-icon"
              />
              </a>
              <a href="https://www.facebook.com/myequation.in" target="_blank">
              <FontAwesomeIcon
                icon={faFacebookSquare}
                color="#fff"
                className="footer__brand-icon"
              />
              </a>
              <a href="https://www.youtube.com/@MyEquation" target="_blank">
              <FontAwesomeIcon
                icon={faYoutubeSquare}
                color="#fff"
                className="footer__brand-icon"
              />
              </a>
              <a href="https://x.com/MyEquation_in" target="_blank">
              <FontAwesomeIcon
                icon={faTwitter}
                color="#fff"
                className="footer__brand-icon"
              /></a>
              <p
                style={{
                  fontSize: "18px",
                }}
              >
                / My Equation
              </p>
            </div>
          </div>
        </div>
        <p
          className="footer-copyright-text"
          style={{
            textAlign: "center",
          }}
        >
          MyEquationTM is a registered trademark under Tech Analogy Pvt Ltd. All rights reserved || <br></br><a target="_blank" href="https://drive.google.com/file/d/1dOmgPLh-Wx378twn0IOIw45OBFZ8uN0G/view?usp=sharing"><b><u> Terms and Conditions </u></b></a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
